module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manual_json":"Manually defined Json","api":"Api","input":"Input","json_schema":"JSON Schema"},"fr":{"manual_json":"Objet Json défini manuellement","api":"Api","input":"Entrée","json_schema":"JSON Schéma"}}')
  delete Component.options._Ctor
}
